import {
  CommonImage,
  LinkLabel,
} from '@porterin/feature/src/shared/types/CommonVM';
import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import Link from 'next/link';
import React from 'react';

import styles from '../styles/Header.module.scss';

interface LegalHeaderCmpProps {
  location_icon: CommonImage;
  company_info: string;
  refund_policy_link: LinkLabel;
  terms_of_service_link: LinkLabel;
}

function LegalHeaderCmp({
  location_icon,
  company_info,
  refund_policy_link,
  terms_of_service_link,
}: Readonly<LegalHeaderCmpProps>): React.ReactElement {
  return (
    <div className={styles['compony-info']}>
      <div className={styles['compony-name']}>
        <NextImageV2
          src={location_icon.path}
          alt={location_icon.alt_text}
          height={24}
          width={24}
          quality={100}
        />
        <div>{company_info}</div>
      </div>
      <div className={styles['links-container']}>
        <Link href={terms_of_service_link.link}>
          {terms_of_service_link.label}
        </Link>
        <Link href={refund_policy_link.link}>{refund_policy_link.label}</Link>
      </div>
    </div>
  );
}

export default LegalHeaderCmp;
